import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const messages = {
    de: {
        saveTitle: 'speichern',
        addTitle: 'Add',
        cancelTitle: 'cancel',
        orders: 'Aufträge',
        products: 'Produkte',
        categories: 'Kategorien',
        shop: 'Shop',
        selectAction: 'Aktion auswählen :',
        details: 'Einzelheiten',
        printTitle: 'drucken',
        alertText: 'Bist du sicher, dass du weitermachen wirst?',
        order_user: 'Benutzer',
        order_fname: 'Vorname',
        order_lname: 'Nachname',
        order_company_name: 'Name der Firma',
        order_street: 'Straße',
        order_aparteman: 'Hausnummer/Stiege/Tür',
        order_post_code: 'Plz',
        order_city: 'Stadt, Dorf',
        order_notes: 'Anmerkungen',
        comment_email: 'Email',
        order_country: 'Country',
        order_transport: 'Lifrung',
        order_number: 'Bestellnummer',
        order_phone: 'phone',
        order_price: 'Preis',
        order_payment_method: 'Zahlungsart',
        save: 'speichern',
        order_pending_text: 'Die Bestellung wird überprüft',
        order_posted_text: 'Die Bestellung wurde gesendet',
        order_return_text: 'Der Kunde hat eine Rückerstattung der Bestellung beantragt',
        order_return_success_text: 'Die Bestellung wurde erfolgreich zurückgesandt',
        order_paying_money_text: 'Der Kunde hat eine Rückerstattung beantragt',
        order_paying_money_returned_success_text: 'Die Bestellung wurde erfolgreich zurückgesandt',
        dateTitle: 'Datum',
        users: 'Benutzer',
        detailsTitle: 'Einzelheiten',
        coupons: 'Gutscheine',
        jobTitle: 'Partnerprogramm',
        stockTitle: 'Lager',

    }
};

const i18n = new VueI18n({
    locale: 'de',
    messages
});
export default i18n;